import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import { Notifier } from '@softwaredev_cegeka/stix-notifier'

import Main from './routes/Main'
import withAuth from './components/auth/withAuth'
import Unauthorized from './routes/Unauthorized'

function App() {
    const MainContent = withAuth(Main)

    return (
        <Notifier>
            <Router>
                <Switch>
                    <Route
                        exact
                        path={'/unauthorized'}
                        component={Unauthorized}
                    />
                    <MainContent />
                </Switch>
            </Router>
        </Notifier>
    )
}

export default App
